import React from "react";
import { FormikErrors } from "formik";
import {
  IdentificationDocumentData,
  LandingPageProxyPassportFormPassenger,
} from "../../../types/IdentificationForm";
import SinglePassenger from "../SinglePassenger";
import styled from "styled-components";
import { Breakpoint } from "../../../enums/Breakpoints";
import Button from "../../../components/TixUiButton";
import { useTranslationV3 } from "../../../i18nV3/useTranslationV3";

interface Props {
  passengers: LandingPageProxyPassportFormPassenger[];
  values: IdentificationDocumentData[];
  setValue: (field: string, value: string) => void;
  errors?: FormikErrors<IdentificationDocumentData | undefined>[];
  handleSubmit: () => void;
}

const FirstStep = ({
  passengers,
  values,
  setValue,
  errors,
  handleSubmit,
}: Props) => {
  const { t } = useTranslationV3();
  return (
    <>
      {passengers.map(
        (passenger, index) =>
          !!values[index] && (
            <SinglePassenger
              {...passenger}
              setFieldData={setValue}
              values={values[index]}
              index={index}
              errors={!!errors ? errors[index] : undefined}
              key={index}
            />
          )
      )}
      <StyledButton onClick={() => handleSubmit()}>
        {t("tix_ui_identification_form_step_1_submit")}
      </StyledButton>
    </>
  );
};

const StyledButton = styled(Button)`
  margin-top: 40px;
  min-width: 275px;
  width: fit-content;

  @media ${Breakpoint.MaxMobile} {
    width: 100%;
  }
`;

export default FirstStep;
